import Styles from './Carousels.module.scss'
import { Carousel } from 'components/Carousel/Carousel'
import { MediaFile } from './MediaFile'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { LoadingCarousel } from './LoadingCarousel'
import { useMediaPickerContext } from '../MediaPickerContext'
import { Provider } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'
import { PropsWithChildren } from 'react'

interface Props {
  mediaFiles: IMediaFile[]
  needsDownload?: boolean
  isLoading?: boolean
  provider?: Provider
}

export const MediaFileCarousel = ({
  mediaFiles,
  needsDownload = false,
  isLoading = false,
  provider,
  children,
}: PropsWithChildren<Props>) => {
  const { handleSelect } = useMediaPickerContext()
  if (isLoading) return <LoadingCarousel />

  return (
    <Carousel slideGap={7} paddingLeft="15px" paddingRight="15px">
      {children}
      {mediaFiles.slice(0, 6).map((file, index) => (
        <div key={index} className={Styles.mediaFileContainer}>
          <MediaFile
            key={file.id}
            file={file}
            src={file.thumbnail_url || file.source_url}
            onPress={() => handleSelect({ file, needsDownload, provider })}
          />
        </div>
      ))}
    </Carousel>
  )
}
